// JOBE-0044.10.3: CollectionsContext — route-level seam that lets the
// rail's CollectionsRailBlock and the omni palette's autocomplete share
// a single GET /api/collections fetch per route mount.
//
// Canonical tri-state shape (mirrors EntityTypesContext /
// DocumentKindsContext):
//   { status: 'loading' | 'ready' | 'error', items: CollectionRow[],
//     error: string | null, retry: () => void }
//
// `items` (not `collections`) keeps the field name aligned with the
// existing CollectionsRailBlock local-state contract so the rail's
// renderer is a near-zero-diff conversion.

import { createContext } from 'react';

// Default value matches the `loading` branch. PR #700 review (NIT):
// `retry: () => {}` mirrors DocumentKindsContext's INITIAL sentinel
// line-by-line per the spec's "near-zero-diff conversion" claim.
// CollectionsRailBlock detects "no provider on the tree" via reference
// identity against COLLECTIONS_INITIAL rather than a `retry == null`
// probe, so this swap is consumer-safe.
export const COLLECTIONS_INITIAL = Object.freeze({
  status: 'loading',
  items: [],
  error: null,
  retry: () => {},
  refresh: () => {},
});

export const CollectionsContext = createContext(COLLECTIONS_INITIAL);
